var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17188 27.2148C0.28125 24.3242 0.242188 21.4727 3.11328 18.6016L18.8555 2.87891C21.7266 0.0078125 24.5781 0.046875 27.4688 2.9375L43.0938 18.5625C45.9844 21.4531 46.0039 24.3242 43.1523 27.1758L27.4297 42.918C24.5586 45.7695 21.707 45.75 18.8164 42.8594L3.17188 27.2148ZM13.6016 22.918C13.6016 23.9141 14.3242 24.5781 15.3398 24.5781H21.4531V30.7109C21.4531 31.707 22.1367 32.4297 23.1133 32.4297C24.1484 32.4297 24.832 31.7266 24.832 30.7109V24.5781H30.9648C31.9609 24.5781 32.6836 23.9141 32.6836 22.918C32.6836 21.9023 31.9805 21.1992 30.9648 21.1992H24.832V15.0859C24.832 14.0703 24.1484 13.3477 23.1133 13.3477C22.1367 13.3477 21.4531 14.0703 21.4531 15.0859V21.1992H15.3398C14.3242 21.1992 13.6016 21.9023 13.6016 22.918Z",
    fill: "#FFC445"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCardIcon);
export default __webpack_public_path__ + "static/media/addCardIcon.10f0cbedea22c537f8bd76f698e0b837.svg";
export { ForwardRef as ReactComponent };